import React from 'react';
import { NavLink, Link } from 'react-router-dom';

import { history } from '../../routers/AppRouter';
import ROUTES from '../../data/routes';


class SidebarMenusSub extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      expanded: false,
    }
  }

  onClick = async (label) => {
    event.preventDefault();
    this.props.setActive(label);
  }

  render() {
    const {
      icon, menu, subMenus
    } = this.props;
    const {
      expanded
    } = this.state;

    return (
      <li className={`has-sub${this.props.isActive(menu.label) === true ? ' active' : ''}`}>
        <Link
          key={menu.id}
          onClick={(e) => { e.preventDefault(); this.props.setActive(menu.label); }}
          to={''}

        >
          <b className={`caret fa fa-${icon}`} />
          <span>{menu.label}</span>
        </Link>
        <ul className="sub-menu">
          {subMenus.map(subMenu => (
            (subMenu.link &&
              <li
                className={subMenu.subMenus ? `has-sub` : ''}
                key={subMenu.id}
              >
                <NavLink
                  exact
                  key={subMenu.id}
                  activeClassName="color-white"
                  onClick={(e) => { this.props.setSub(subMenu.label); history.push(menu.link) }}
                  to={ROUTES[subMenu.link] || ''}
                >
                  {subMenu.label}
                  {(subMenu.link === 'REGISTER_SOLICITATION' && companyTag === 'chile')
                    && (<span className='notificationPendingSolicitationMenu'>{countOfPendingRequests}</span>)}
                </NavLink>
              </li>
            ) ||
            (subMenu.subMenus &&
              <SidebarMenusSub
                key={subMenu.id}
                icon={subMenu.icon || "list-ol"}
                menu={{
                  label: subMenu.label,
                }}
                subMenus={subMenu.subMenus}
                isActive={this.props.isActive}
                setActive={this.props.setActive}
              />
            )
          ))}
        </ul>
      </li>
    );
  }
}

export default SidebarMenusSub;
